import { useTheme } from '@emotion/react';
import React from 'react';

import { Button, Icon, Text } from '~/components/blocks';

type Props = {
  disabled?: boolean;
  onClick?: () => void;
};

export const UnlinkButton = (props: Props) => {
  const theme = useTheme();

  return (
    <Button
      size="ms"
      padding={`1px ${theme.space.m}`}
      marginRight={theme.space.s}
      disabled={props.disabled}
      onClick={props.onClick}
    >
      <Icon size="s" icon="not-sync" color="blue" />
      <Text size="xs">連携解除</Text>
    </Button>
  );
};
